import { applyAction } from "./appliers";
import type { GreatKingdomAction, GreatKingdomState } from "./types";
import { validateAction } from "./validators";

export interface ReduceResult {
  readonly state: GreatKingdomState;
  readonly accepted: boolean;
  readonly error?: string;
}

export function reduceGameState(
  state: GreatKingdomState,
  action: GreatKingdomAction,
): GreatKingdomState {
  return applyAction(state, action);
}

export function validateAndReduceGameState(
  state: GreatKingdomState,
  action: GreatKingdomAction,
): ReduceResult {
  const validation = validateAction(state, action);
  if (!validation.valid) {
    return {
      state,
      accepted: false,
      error: validation.error,
    };
  }

  return {
    state: reduceGameState(state, action),
    accepted: true,
  };
}
